import React, { forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Row, Col } from 'antd';
import Title from 'antd/es/typography/Title';
import SameForAll from './SameForAll';
import DifferentForEach from './DifferentForEach';

export default forwardRef((props: any, ref: any) => {
  const isSameForAll = props.inputData.options[props.language]
                       .every((option)=>option.select===1);

  return (
    <FormItem
      colon={false}
    >
      <Title level={2}>
        <Row type="flex" justify="center">
          <Col span={16}>
          {isSameForAll && (
            <SameForAll {...props} />
          )}
          {!isSameForAll && (
            <DifferentForEach {...props} />
          )}
          </Col>
        </Row>
      </Title>
    </FormItem>
  );
});
